export default "__VITE_ASSET__DAopxY1F__"